<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商品入库列表</div>
    </div>
    <div
      v-if="searchOptions"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in searchOptions && searchOptions.optionsWhere"
        :key="item.key"
        class="status"
        :class="{ active: where === item.key }"
        @click="selectWhere(item.key)"
      >
        {{ item.label }}({{ where == item.key ? tempCount : 0 }})
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.goods_no"
                      placeholder="商品货号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.sku"
                      placeholder="sku"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_name"
                      placeholder="商品名称"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.market_name"
                      placeholder="市场"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.brand_name"
                      placeholder="品牌"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.woid"
                      placeholder="代采单号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.package_no"
                      placeholder="包裹号"
                      clearable
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.pici_no"
                      placeholder="批次号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.dbid"
                      placeholder="打标id"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item v-if="searchOptions">
                    <el-select
                      v-model="form.status"
                      multiple
                      placeholder="状态"
                    >
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.optionsStatus"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="searchOptions">
                    <el-select
                      v-model="form.is_work_id"
                      placeholder="是否工单商品"
                    >
                      <el-option
                        v-for="item in is_work_id"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="searchOptions">
                    <el-input
                      v-model="form.desk_no"
                      placeholder="工作台"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item v-if="searchOptions">
                    <el-select
                      v-model="form.da_biao_method"
                      placeholder="代采欠货打标方式"
                    >
                      <el-option value="" label="全部"></el-option>
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.optionPurchaseDaBiaoMethod"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="searchOptions">
                    <el-select
                      v-model="form.create_type"
                      placeholder="批次创建方式"
                    >
                      <el-option value="0" label="全部"></el-option>
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.optionsPiciType"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="searchOptions">
                    <el-select
                      v-model="form.exception_dbid_source"
                      placeholder="异常来源"
                    >
                      <el-option value="" label="全部"></el-option>
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.exceptionSourceOp"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.dgid"
                      filterable
                      placeholder="次品组"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in searchOptions && searchOptions.dg_group"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.dpc_id"
                      filterable
                      placeholder="退换货负责人"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.option_dgm"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.refunder_id"
                      filterable
                      placeholder="售后退供员"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.dgm_refunder"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_kh"
                      placeholder="款号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_compensate"
                      filterable
                      placeholder="是否买赔商品"
                    >
                      <el-option label="全部" :value="0"></el-option>
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.optionIsCompensate"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.planid"
                      placeholder="代采计划单号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
            <div style="padding: 0 25px">
              <el-form
                v-if="searchOptions"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item label="入库时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.origin" placeholder="选择仓库">
                    <el-option
                      v-for="item in searchOptions &&
                      searchOptions.optionsOrigin"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.where" placeholder="选择仓区">
                    <el-option
                      v-for="item in searchOptions &&
                      searchOptions.optionsWhere"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    multiple
                    filterable
                    placeholder="选择代采组"
                  >
                    <el-option
                      v-for="item in searchOptions && searchOptions.optionsPg"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="searchOptions">
                  <el-select
                    v-model="form.order_owner"
                    filterable
                    placeholder="订单负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions &&
                      searchOptions.owner_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.picker_group"
                    placeholder="选择买手组"
                  >
                    <el-option
                      v-for="item in searchOptions && searchOptions.optionsMs"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.type"
                    multiple
                    placeholder="选择入库来源"
                  >
                    <el-option
                      v-for="item in searchOptions && searchOptions.optionsType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.blp_type"
                    multiple
                    placeholder="不良品类型"
                  >
                    <el-option
                      v-for="item in searchOptions && searchOptions.optionsblp"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.the_level"
                    placeholder="选择次品等级"
                  >
                    <el-option
                      v-for="item in searchOptions &&
                      searchOptions.optionsLevel"
                      :key="item.key"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.has_suit_parts"
                    placeholder="是否带配件/套装"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option value="1" label="是"></el-option>
                    <el-option value="2" label="否"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总&nbsp;&nbsp;&nbsp;&nbsp;入库总数{{
          resData.stock_total_num
        }}件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;入库金额：¥{{
          resData.stock_total_price
        }}
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            align-items: center;
            position: relative;
          "
        >
          <div style="position: absolute; right: 0; top: 0">
            <el-date-picker
              v-if="show_exc_time == 1"
              v-model="form.excetion_time"
              size="mini"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :default-time="['06:00:00', '06:00:00']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-button type="danger" size="mini" @click="oweRebackApply">
              申请恢复欠货
            </el-button>
            <!-- <el-button type="danger" size="mini" @click="exChangeOweShow">置换欠货</el-button> -->
            <el-button
              style="margin-right: -18px"
              type="info"
              size="mini"
              @click="show_exc_time = !show_exc_time"
              ><i class="el-icon-date"
            /></el-button>
            <el-button type="info" size="mini" @click="outputExcetionData">
              异常日志导出
            </el-button>
            <el-button type="danger" size="mini" @click="markExcept">
              标记异常
            </el-button>
            <el-button type="success" size="mini" @click="markNormal">
              恢复正常
            </el-button>
            <el-button type="danger" size="mini" @click="importDbid(2)">
              批量导入标记异常</el-button
            >
            <el-button type="success" size="mini" @click="importDbid(1)">
              批量导入恢复正常</el-button
            >
            <el-button
              style="margin-left: auto"
              type="info"
              size="mini"
              @click="output"
              >导出</el-button
            >
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column
              prop="goods_img"
              label="商品图片"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column
              v-if="where === 3"
              :key="blp_img"
              prop="blp_img"
              label="换回商品图片"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.blp_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="package_no" label="包裹号" align="center">
            </el-table-column>
            <el-table-column
              prop="package_create_time"
              label="包裹生成时间"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pici_no" label="批次号" align="center">
            </el-table-column>
            <el-table-column
              prop="pici_create_type"
              label="批次创建方式"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="desk_no" label="工作台" align="center">
            </el-table-column>
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="is_gift" label="是否赠品" align="center">
            </el-table-column>
            <el-table-column
              prop="is_cross_order_dbid"
              label="是否跨仓调拨"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dbid"
              label="打标id"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.dbid }}
                </div>
                <el-tag v-if="scope.row.is_compensate_msg" color="009DD9">
                  {{ scope.row.is_compensate_msg }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="sku_text"
              label="货号/颜色/尺码"
              width="200px"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="sku" label="sku" align="center">
            </el-table-column>
            <el-table-column
              prop="has_suit_parts"
              label="是否带配件/套装"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="价格"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market"
              label="商家/品牌/市场"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pg" label="买手组/代采组" align="center">
            </el-table-column>
            <el-table-column
              prop="owner_admin_name"
              label="订单负责人"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dg_group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              label="退换货负责人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refunder"
              label="售后退供员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dispute_goods_str"
              label="争议商品"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="purchase_da_biao_method"
              label="打标方式"
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="where === 3"
              prop="category"
              label="类别"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="stock_in_record_stock_source"
              label="入库来源"
              align="center"
            >
              <template #default="{ row }">
                <div>{{ row.stock_in_record_stock_source }}</div>
                <div v-if="row.is_transit_formal" style="color: #006cff">
                  {{ row.is_transit_formal }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="sdbr_text"
              label="是否爆版打标"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column prop="blp_type" label="不良品类型" align="center">
            </el-table-column>
            <el-table-column
              prop="woid"
              label="代采订单"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="psp_id"
              label="前置仓计划编号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="ow" label="仓库" align="center">
            </el-table-column>
            <el-table-column
              prop="source_where_text"
              label="原库区"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="status_text"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exception_dbid_source"
              label="异常来源"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exchange_calc_date"
              label="开始计算时间"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle"
              label="入库时间/入库人"
              width="100"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <!-- 批量导入 -->
    <el-dialog title="批量导入恢复正常" :visible.sync="dialogNormal">
      <el-upload
        ref="upload2"
        class="upload-demo"
        :action="action2"
        :limit="1"
        :file-list="fileListNor"
        :data="{ markType: 2 }"
        :auto-upload="false"
        :on-success="submitSuccess"
        with-credentials
      >
        <el-button size="small" type="primary">选择文件</el-button>
        <div slot="tip" class="el-upload__tip">
          请先下载模板,跟模板一样格式,并且确保每行数据正确,不能为空
        </div>
      </el-upload>
      <br />
      <div style="color: red">
        {{ uploadErrorMsg }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="importDbid(3, 2)"
          >下载模板</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpload(2)"
          >上传到服务器</el-button
        >
        <el-button @click="dialogNormal = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量导入标记异常"
      :visible.sync="dialogExcept"
      :close-on-click-modal="false"
      @close="handleBatchExceptionClose"
    >
      <el-form ref="formBatchException" :model="formBatchException">
        <el-form-item label="" prop="file">
          <ys-upload-combo
            v-model="formBatchException.file"
            :download-temp="handleTemplateDownload"
            btn-upload="选择文件"
            btn-list=""
          ></ys-upload-combo>
          <div>请先下载模板,跟模板一样格式,并且确保每行数据正确,不能为空</div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogExcept = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBatchException">
          确定
        </el-button>
      </template>
    </el-dialog>

    <!-- 置换欠货的弹窗 -->
    <el-dialog title="置换欠货" :visible.sync="exChange.show">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="exChange.search_form.select_key">
            <el-option
              v-for="item in exChange.sekectKeyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="exChange.search_form.select_val"
            :placeholder="
              '请输入' +
              exChange.sekectKeyOptions[exChange.search_form.select_key - 1]
                .label
            "
          ></el-input>
        </el-form-item>
        <el-button type="infor" @click="exChangeOweFetch">查询</el-button>
      </el-form>
      <el-table
        ref="exchange_table"
        :data="exChange.rs"
        height="400px"
        @select="exChangeSelection"
        @select-all="
          () => {
            $message.error('请勿全选');
            $refs.exchange_table.clearSelection();
          }
        "
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="款号" prop="goods_kh"></el-table-column>
        <el-table-column label="货号/颜色/尺码">
          <template slot-scope="scope">
            {{ scope.row.goods_no }}/{{ scope.row.co_val }}/{{
              scope.row.si_val
            }}
          </template>
        </el-table-column>
        <el-table-column label="欠货类型">
          <span> 代采欠货 </span>
        </el-table-column>
        <el-table-column label="欠货数量" prop="owe_num"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="infor" @click="exChange.show = false">取消</el-button>
        <el-button type="primary" @click="exChangeOweDo">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="申恢复欠货"
      :visible.sync="isShowRebackDialog"
      width="600px"
      @close="isShowRebackDialog = false"
    >
      <el-form label-position="left" label-width="80px">
        <el-form-item label="申请数量: ">{{
          multipleSelection.length
        }}</el-form-item>
        <el-form-item label="申请说明: ">
          <el-input
            v-model="oweRebackApplyRemark"
            type="textarea"
            :rows="6"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="isShowRebackDialog = false">取 消</el-button>
        <el-button type="primary" @click="doApplyReback">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="标记异常"
      :visible.sync="isShowAbnormalSourceDialog"
      :close-on-click-modal="false"
      width="600px"
      @close="handleMarkExceptClose"
    >
      <el-form ref="formException" :model="formException" label-width="80px">
        <el-form-item
          label="异常来源"
          prop="exceptionSource"
          :rules="rules.ruleChange"
        >
          <el-radio-group v-model="formException.exceptionSource">
            <el-radio :label="4">改标异常</el-radio>
            <el-radio :label="1">其他异常</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="异常原因"
          prop="exceptionReasonSingle"
          :rules="rules.ruleChange"
        >
          <el-select v-model="formException.exceptionReasonSingle">
            <el-option
              v-for="item in optionsMap.reasonList"
              :key="item.rdid"
              :label="item.rdname"
              :value="item.rdid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="责任部门" prop="responsibilityDeptSingle">
          <el-cascader
            v-model="formException.responsibilityDeptSingle"
            :options="optionsMap.departmentList"
            :props="{ checkStrictly: true }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="责任人" prop="responsibilityPersonal">
          <ys-input
            v-model="formException.responsibilityPersonal"
            :maxlength="constantMap.maxName"
            :placeholder="`最长${constantMap.maxName}个字符`"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowAbnormalSourceDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmException">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import rules from "@/const/rules.js";
import * as modiCommonConfigApi from "@/controller/modiCommonConfig3652.js";
import * as goodsManageApi from "@/controller/goodsManage3642.js";
import * as preStockManageApi from "@/controller/preStockManage3155.js";
import { openDownloadWindow } from "@/utils/export.js";

const constantMap = Object.freeze({
  department: "zerenbumen",
  reason: "yichangyuanyin",
  isUse: "1",
  isAll: "2",
  maxName: 50,
  isException: "1", // 异常
});
const changeCascaderData = (data) => {
  return data?.map((item) => {
    const { rdname, rdid, children, ...rest } = item;
    return changeCascaderData(children)?.length
      ? {
          ...rest,
          label: item.rdname,
          value: item.rdid,
          children: changeCascaderData(children),
        }
      : {
          ...rest,
          label: item.rdname,
          value: item.rdid,
        };
  });
};

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let search = false;
      if (vm.$route.params.pg_member_id) {
        vm.$set(vm.form, "pg_member_id", vm.$route.params.pg_member_id);
      }
      if (vm.$route.params.data_time) {
        const tr = vm.$route.params.data_time.split("~");
        vm.$set(vm.form, "create_time", tr);
      }
      if (vm.$route.params.origin) {
        vm.$set(vm.form, "origin", Number(vm.$route.params.origin));
      }
      if (
        vm.$route.params.pg_member_id &&
        vm.$route.params.data_time &&
        vm.$route.params.origin
      ) {
        search = true;
      }
      if (vm.$route.params.p) {
        if (vm.$route.params.p < 100) {
          vm.$set(vm.form, "create_type", 2);
          vm.$set(vm.form, "blp_type", Number(vm.$route.params.p));
        } else {
          vm.$set(vm.form, "type", 8);
        }
      }
      vm.fetchData(false, () => {
        if (search) {
          vm.$set(vm.form, "create_type", 2);
          vm.search();
        }
        if (vm.$store.state.fromCommodity) {
          Object.assign(
            vm.form,
            JSON.parse(JSON.stringify(vm.$store.state.fromCommodity))
          );
          // eslint-disable-next-line no-param-reassign
          delete vm.$store.state.fromCommodity;
          vm.search();
        }
      });
    });
  },
  data() {
    return {
      constantMap,
      rules,
      resData: null,
      form: {
        create_time: this.defaultDate(),
        status: [],
        origin: 1,
        the_level: "",
        has_suit_parts: "",
        is_compensate: "",
        planid: "",
      },
      loading: false,
      url: "/erp/StockInRecord/list",
      where: -1,
      curPage: 1,
      tempCount: 0,
      tableLoading: false,
      show_exc_time: 0,
      filterFold: false,
      multipleSelection: [],
      fileListNor: [],
      fileListExp: [],
      is_work_id: [
        {
          key: 0,
          label: "全部",
        },
        {
          key: 1,
          label: "是",
        },
        {
          key: 2,
          label: "不是",
        },
      ],
      is_supply_dbid_option: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      searchOptions: null,
      dialogNormal: false,
      dialogExcept: false,

      exChange: {
        rs: [],
        show: false,
        form: { dbid: 0, sku: 0 },
        search_form: { select_key: 1, select_val: "" },
        sekectKeyOptions: [
          { label: "款号", value: 1 },
          { label: "货号", value: 2 },
          { label: "sku编号", value: 3 },
        ],
        selection: null,
      },

      isShowRebackDialog: false,
      oweRebackApplyRemark: "",
      optionPgMember: [],
      exceptionSource: "",
      isShowAbnormalSourceDialog: false, // 异常来源弹窗
      formException: {
        exceptionSource: "",
        exceptionReasonSingle: "",
        responsibilityDeptSingle: [],
        responsibilityPersonal: "",
      },
      optionsMap: {
        departmentList: [],
        reasonList: [],
      },
      formBatchException: {
        markType: 1, // 标记异常
        file: null,
      },
      uploadErrorMsg: "",
      action2: `${apiBaseURL}/erp/StockInRecord/editStockException?import=2`,
      action1: `${apiBaseURL}/erp/StockInRecord/editStockException?import=1`,
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      });
      return this.form;
    },
  },

  methods: {
    handleGetOptions() {
      modiCommonConfigApi
        .operationReasonOption({
          key: constantMap.department,
          query_scope: constantMap.isUse,
        })
        .then((res) => {
          this.optionsMap.departmentList = changeCascaderData(res);
        })
        .catch(this.$noop);
      modiCommonConfigApi
        .operationReasonOption({
          key: constantMap.reason,
          query_scope: constantMap.isUse,
        })
        .then((res) => {
          this.optionsMap.reasonList = res;
        })
        .catch(this.$noop);
    },
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(-1, 6);
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        let newRes = res;
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          if (JSON.stringify(res.data.data.list) !== "[]") {
            newRes = this.resFormat(res);
          }
          this.resData = newRes.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(`/home/purchaseorderdetail/${row.woid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.form.get_search_options = 0;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        let newRes = res;
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          if (JSON.stringify(res.data.data.list) !== "[]") {
            newRes = this.resFormat(res);
          }
          this.resData = newRes.data.data;
          this.tempCount = this.resData.count;
          this.where = this.filteredForm.where;
          this.curPage = 1;
        }
      });
    },
    selectWhere(key) {
      this.where = key;
      this.form.where = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        let newRes = res;
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          if (JSON.stringify(res.data.data.list) !== "[]") {
            newRes = this.resFormat(res);
          }
          this.resData = newRes.data.data;
          this.tempCount = this.resData.count;
        }
      });
    },
    fetchData(showLoading, callback) {
      if (showLoading) {
        this.loading = true;
      }
      this.form.get_search_options = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.searchOptions = res.data.data;
        }
        if (typeof callback === "function") {
          callback();
        }
      });
    },
    markExcept() {
      if (!this.multipleSelection.length) {
        this.$message.info("请先勾选商品");
        return;
      }
      this.handleGetOptions();
      this.isShowAbnormalSourceDialog = true;
    },
    handleMarkExceptClose() {
      this.$refs.formException.resetFields();
      this.formException = {
        exceptionSource: "",
        exceptionReasonSingle: "",
        responsibilityDeptSingle: [],
        responsibilityPersonal: "",
      };
    },
    markNormal() {
      this.markSave(2);
    },
    markSave(theType) {
      // 恢复为正常状态
      if (this.multipleSelection.length < 1) {
        this.$message.info("请勾选商品");
        return;
      }
      let dbids = new Array(this.multipleSelection.length);
      for (let i = this.multipleSelection.length - 1; i >= 0; i--) {
        dbids[i] = this.multipleSelection[i].dbid;
      }
      dbids = dbids.join(",");
      const params = {
        dbids,
        markType: theType,
        exceptionSource: this.exceptionSource,
      };
      const url = "/erp/StockInRecord/editStockException";
      this.tableLoading = true;
      this.$http.post(url, params).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$notify({
            title: "操作成功",
            message: res.data.msg,
            type: "success",
          });
          this.multipleSelection = [];
          this.exceptionSource = "";
          this.isShowAbnormalSourceDialog = false;
        }
        this.search();
        this.tableLoading = true;
      });
    },
    resFormat(res) {
      res.data.data.list.map((item) => {
        const dealItem = item;
        dealItem.sku_text = `${item.goods_no} / ${item.co_val} / ${item.si_val}`;
        dealItem.pg = `${item.pg_name} / ${item.pgname}`;
        dealItem.rk = `${item.type_text} / ${item.bd_type_text} / ${item.blp_type}`;
        dealItem.ow = `${item.origin} / ${item.where_text}`;
        dealItem.handle = `${item.create_time} / ${item.admin_name}`;
        dealItem.market = `${item.supply_name} / ${item.brand_name} / ${item.market_name}`;
        dealItem.user = `${item.order_id} / ${item.user_id}`;
        return dealItem;
      });
      return res;
    },
    outputExcetionData() {
      this.form.is_excel = 1;
      this.loading = true;
      this.form.origin = this.origin;
      this.form.log = 1;
      this.$http
        .post("/erp/StockInRecord/exportExceptionData", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.form.is_excel = 0;
            this.loading = false;
            this.$message.error(res.data.msg);
          } else {
            this.loading = false;
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
          this.form.log = "";
        });
    },
    submitUpload(e) {
      if (e === 1) {
        this.$refs.upload1.submit();
      } else {
        this.$refs.upload2.submit();
      }
    },

    handleTemplateDownload() {
      goodsManageApi
        .editStockException({ template: 1, markType: 1 })
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    handleBatchExceptionClose() {
      this.$refs.formBatchException.resetFields();
      this.formBatchException = {
        markType: 1, // 标记异常
        file: null,
      };
    },
    handleConfirmBatchException() {
      this.$refs.formBatchException.validate((valid) => {
        if (valid) {
          preStockManageApi
            .editStockExceptionImport_1(
              {
                markType: constantMap.isException,
                ...this.formBatchException,
              },
              { useDataField: false }
            )
            .then((res) => {
              this.dialogExcept = false;
              if (res.data.data?.file) {
                openDownloadWindow(res.data.data);
              } else {
                this.$confirm("", {
                  type: "success",
                  title: "提示",
                  message: `操作成功，${res.data.msg}`,
                  showCancelButton: false,
                });
              }
              this.search();
            })
            .catch(this.$noop);
        }
      });
    },

    // type 1-导入正常,2-导入异常,3-下载模板 markType批量导入时需带上参数{2:恢复正常,1:异常}
    importDbid(type, markType) {
      this.uploadErrorMsg = "";
      if (type === 3) {
        this.$http
          .post("/erp/StockInRecord/editStockException", {
            template: 1,
            markType,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } else if (type === 1) {
        this.dialogNormal = true;
      } else if (type === 2) {
        this.dialogExcept = true;
      }
    },
    submitSuccess(response) {
      this.$confirm(response.msg, "提示", {
        closeOnClickModal: false,
        closeOnHashChange: false,
        showCancelButton: false,
      })
        .then(() => {
          if (response.code !== 200) {
            this.$refs.upload1.clearFiles();
            this.$refs.upload2.clearFiles();
          } else {
            this.uploadErrorMsg = response.data.errMsg;
            if (response.data.file) {
              window.open(apiBaseURL + response.data.file);
            }
            this.fetchData();

            this.dialogNormal = false;
            this.dialogExcept = false;
            this.$refs.upload1.clearFiles();
            this.$refs.upload2.clearFiles();
          }
        })
        .catch(() => {});
    },

    // 置换欠货的弹窗
    exChangeOweShow() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请先勾选打标id");
        return false;
      }

      if (this.multipleSelection.length > 1) {
        this.$message.error("一次只能置换一个打标id");
        return false;
      }
      this.$set(this.exChange.form, "dbid", this.multipleSelection[0].dbid);
      this.exChangeOweFetch().then(() => {
        this.$set(this.exChange, "show", true); // 等下把这行挪下去请求成功里面
      });
      return true;
    },

    // 请求弹窗内的数据
    exChangeOweFetch() {
      return new Promise((resolve) => {
        this.$http
          .post("/erp/ExChange/exChangeSupplyGoods", {
            dbid: this.exChange.form.dbid,
            ...this.exChange.search_form,
          })
          .then((rs) => {
            if (rs.data.code !== 200) {
              this.$message.error(rs.data.msg);
            } else {
              this.$set(this.exChange, "rs", rs.data.data);
              resolve(rs.data.data);
            }
          });
      });
    },

    // 以下为恢复欠货用的方法
    oweRebackApply() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请先勾选");
      } else {
        this.isShowRebackDialog = true;
        this.oweRebackApplyRemark = "";
      }
    },

    doApplyReback() {
      // if (this.oweRebackApplyRemark.length == 0) return this.$message.error('请填写申请备注');
      const dbids = [];
      this.multipleSelection.forEach((v) => {
        dbids.push(v.dbid);
      });
      this.$http
        .post("/erp/OweReback/oweRebackApply", {
          dbids,
          remark: this.oweRebackApplyRemark,
        })
        .then((rs) => {
          if (rs.data.code !== 200) {
            this.$message.error(rs.data.msg);
          } else {
            this.$message.success("申请成功! 请等待审核");
            this.isShowRebackDialog = false;
          }
        })
        .catch(() => {
          this.$message.error("服务器错误! 请联系管理员");
        });
    },

    // 勾选被置换的sku
    exChangeSelection(val, row) {
      if (val.length > 1) {
        this.$refs.exchange_table.toggleRowSelection(val[0], false);
      }
      if (row.owe_num === 0) {
        this.$refs.exchange_table.toggleRowSelection(row, false);
        return this.$message.error("此sku欠货数量不足");
      }
      this.$set(this.exChange.form, "sku", row.sku);
      return true;
    },

    // 确定置换欠货
    exChangeOweDo() {
      this.$http
        .post("/erp/ExChange/exChanageDo", this.exChange.form)
        .then((rs) => {
          if (rs.data.code !== 200) return this.$message.error(rs.data.msg);
          this.$message.success("置换成功! ");
          console.log(JSON.stringify(rs.data.data));
          this.printQrCode(rs.data.data);
          this.$set(this.exChange, "show", false);
          return true;
        }); // .catch(()=>this.$message.error('服务器错误! 请联系管理员'))
    },

    // socket打印置换后的二维码
    printQrCode(data) {
      let wsuri = "";
      // 连接websocket
      const socketInit = new Promise((resolve) => {
        const ishttps = document.location.protocol === "https:";
        if (ishttps) {
          wsuri = "wss://localhost:13529"; // https wss地址
        } else {
          wsuri = "ws://localhost:13528"; // ws地址
        }

        const websocket = new window.WebSocket(wsuri);

        websocket.onerror = () => {
          this.$message.error("连接打印机失败! 请检查插件是否启动");
        };

        websocket.onmessage = () => {};
        websocket.onopen = () => resolve(websocket);
      });

      socketInit
        .then((socket) => {
          socket.send(JSON.stringify(data));
        })
        .catch();
    },

    handleConfirmException() {
      this.$refs.formException.validate((valid) => {
        if (valid) {
          const { responsibilityDeptSingle, ...rest } = this.formException;
          const dbidList = this.multipleSelection.map((item) => item.dbid);
          goodsManageApi
            .editStockException({
              markType: constantMap.isException,
              dbids: dbidList.join(","),
              responsibilityDeptSingle:
                responsibilityDeptSingle[responsibilityDeptSingle.length - 1] ||
                "0",
              ...rest,
            })
            .then(() => {
              this.$message.success(`操作成功，成功处理${dbidList.length}条!`);
              this.isShowAbnormalSourceDialog = false;
              this.multipleSelection = [];
              this.search();
            })
            .catch(this.$noop);
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/StockInList.vue